<script setup lang="ts">
const { $gsap, $ScrollTrigger } = useNuxtApp()
$gsap.registerPlugin($ScrollTrigger)

const showCookieBanner = ref(false)

function acceptCookies() {
  showCookieBanner.value = false
  localStorage.setItem("cookiesAccepted", "true")
}
onMounted(() => {
  if (localStorage.getItem("cookiesAccepted") !== "true") {
    showCookieBanner.value = true
  }
})
</script>

<template>
  <NuxtPage />
  <div v-if="showCookieBanner" class="cookie-banner">
    <h5>Мы используем cookies</h5>
    <p>
      Для улучшения работы сайта. Подробнее – в
      <a target="_blank" href="/oferta">
        Политике обработки персональных данных.
      </a>
      Продолжая пользоваться сайтом, Вы даете согласие на использование файлов
      cookies. <br /><br />
      Если Вы не согласны на использование файлов cookies, Вам необходимо
      установить специальные настройки в браузере или покинуть сайт.
    </p>
    <div class="cookie-buttons">
      <button class="btn-decline" @click="acceptCookies">OK</button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cookie-banner {
  position: fixed;
  bottom: 15px;
  left: 15px;
  right: 15px;
  z-index: 99;
  color: #4c4c4c;
  padding: 25px;
  background: #fff;
  max-width: 400px;
  border-radius: 20px;
  h5 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 10px;
    line-height: 150%;
  }
  p {
    font-size: 14px;
    margin: 0 0 20px;
    line-height: 150%;
    a {
      text-decoration: underline;
    }
  }
  .cookie-buttons {
    display: flex;
    gap: 15px;
    /* flex: 1 1 auto; */
    button {
      /* flex: 1; */
      padding: 10px 30px;
      border-radius: 50px;
      text-align: center;
      &:nth-child(1) {
        background: linear-gradient(270deg, #6a45ff 0%, #a38cff 100%);

        color: #fff;
        border: none;
      }
    }
  }
}
</style>
